class FilterComplains {
  constructor() {

    if(document.querySelector('.filter-complains') != null && document.querySelector('.filter-complains') != undefined) {
      this.setEvents();
    }
  }

  setEvents() {  

    var acc = document.getElementsByClassName("filter__title");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        event.preventDefault();
        var panel = this.nextElementSibling;
        var filter = this.parentNode;
        if (filter.classList.contains('active')) {
          panel.style.maxHeight = 0;
          filter.classList.toggle("active");
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
          filter.classList.toggle("active");
        };
      });
    };
  };

};

$(document).ready(function() {
  const filterComplains = new FilterComplains();
});
